import { RootState } from "../store";

export const selectSharedDefects = (state: RootState) => state.sharedDefects;

export const selectSharedDefectsData = (state: RootState) => state.sharedDefects.data;

export const selectSharedDefectsLoading = (state: RootState) => state.sharedDefects.loading;

export const selectPreviousRecipients = (state: RootState) => state.sharedDefects.previousRecipients;
